import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withOffshorePositionAndWeatherEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
